export const REQUIRED_SHEET_MISSING = '底表必要sheet缺失';
export const REQUIRED_SHEET_COLUMNS_MISSING = '表缺失必要列';
export const DRIVER_FOLDER_NOT_EXIST = '没有Drive Folder';
export const CONTACT_PEOPLE_EMAIL_NOT_EXIST = '没有对接人邮箱';
export const YEAR_DRIVER_FOLDER_OR_BILL_SPLIT_DRIVER_FOLDER_NOT_EXIST = '年Drive Folder或账单拆分Drive Folder不存在';
export const U_NAME_MISSING = '没有MU/BU';